module.exports = __webpack_public_path__ + "fonts/voicecall@2x.58dd772b2707df0cc986796f249ae80c.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/voicecall@2x.png
// module id = 798
// module chunks = 9